import React, { useEffect, useState } from 'react';
import { isValidate } from '../services/api';
import { Navigate, Outlet } from 'react-router-dom';
import ScreenLoading from '../ScreenLoading';

export default function ProtectedRoute() {
    const [status, setStatus] = useState('loading');
    useEffect(() => {
        const validate = async () => {
            try {
                const result = await isValidate();
                if (result?.d === true) {
                    setStatus('valid');
                } else if (result?.d === false) {
                    setStatus('login');
                } else {
                    setStatus('login');
                }
            } catch {
                setStatus('login');
            }
        };
        validate();
    }, []);

    if (status === 'loading') return <ScreenLoading />;
    if (status === 'login') return <Navigate to='/' replace />;
    if (status === 'subscription') return <Navigate to='/subscription' replace />;

    return <Outlet />

}
